import React, { Fragment } from 'react';

import useClubPreCompetitiveProgramsRead from './UseClubPreCompetitiveProgramsRead';

import ClubPreCompGridRead from './ClubPreCompGridRead';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import Constants from '@usas/ui-web/utils/Constants';

const ClubPreCompetitiveProgramsRead = () => {
  const { usasClubPreCompLinksState, baseUsasClubState } = useClubPreCompetitiveProgramsRead();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Pre-Competitive Programs</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <ClubPreCompGridRead
            data={usasClubPreCompLinksState.arrayData}
            isLoading={usasClubPreCompLinksState.isArrayLoading} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={baseUsasClubState.isObjLoading || usasClubPreCompLinksState.isArrayLoading} />
    </Fragment >
  );
};

export default ClubPreCompetitiveProgramsRead;